module.exports = __webpack_public_path__ + "img/yiqi2.663fa354.png";